var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"calm-footer"},[_c('div',{staticClass:"calm-footer__copy"},[_vm._v(" © "+_vm._s(_vm.year)+" "),_c('a',{staticClass:"calm-footer__link",attrs:{"href":_vm.appUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.appName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }